/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import { withAnalytics } from '@veneer/analytics';
import { Card } from '@veneer/core';
import React, { memo } from 'react';
import './styles.scss';
import { EmptyCardProps } from './types';
import { generateID } from '../../base/helper';

const TEmptyCard: React.FC<EmptyCardProps> = ({
  children,
  onClick,
  id = generateID('clientos-ui-toolkit-empty-card')
}) => {
  return (
    <div
      className={`clientos-ui-toolkit-empty-card ${onClick ? 'clientos-ui-toolkit-empty-card--clickable' : ''}`}
      id={`${id}`}
    >
      <Card
        className="clientos-ui-toolkit-empty-card__content"
        content={children}
        onClick={onClick}
        id={`${id}__content`}
      />
    </div>
  );
};

export const EmptyCardAnalytics = withAnalytics(TEmptyCard);
export default memo(TEmptyCard);
